import { ReactElement, ReactNode } from 'react';
import { UIText } from '@/ui';

export type SectionRowProps = {
    label: string;
    description: string;
    /** Optional inline node rendered after the label (e.g. an "(Upgrade required)" suffix). */
    labelAccessory?: ReactNode;
    /** Vertical alignment of the label against the content. Defaults to 'center'. */
    align?: 'center' | 'flex-start';
    children: ReactNode;
};

/**
 * A device-settings section row: label + description on the left, content
 * (value or action) on the right. Shared by the General and Actions sections.
 */
export function SectionRow(props: SectionRowProps): ReactElement {
    const {
        label,
        description,
        labelAccessory,
        align = 'center',
        children
    } = props;
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: align,
                gap: 16
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    gap: 4
                }}
            >
                <UIText>
                    {label}
                    {labelAccessory}
                </UIText>
                <UIText type="default2">{description}</UIText>
            </div>
            <div style={{ display: 'flex', flex: 1 }}>{children}</div>
        </div>
    );
}
